import _ from 'lodash'
import { FIELD as TABLE_SORT_FIELD } from '../Dashboard/OperatingDashboard/SearchKeywords/constants'
import {
  GA_KEY as DASHBOARD_KEY
} from '../Dashboard/OperatingDashboard/SearchKeywords/SearchKeywords.ga'

export const GA_CLICK_ACTION = {
  TABLE_SORT: 'TABLE_SORT',
  VIEW_GD: 'VIEW_GD'
}

const COMMON_GA_KEYS = [
  DASHBOARD_KEY.TABLE_SORT_CLICKS,
  DASHBOARD_KEY.TABLE_SORT_IMPRESSIONS,
  DASHBOARD_KEY.TABLE_SORT_CTR
]

const GA_KEY = {
  ..._.pick(DASHBOARD_KEY, COMMON_GA_KEYS)
}

const GA_KEY_MAP = {
  [GA_KEY.TABLE_SORT_CLICKS]: 'keyword_list_orderclick',
  [GA_KEY.TABLE_SORT_IMPRESSIONS]: 'keyword_list_orderimpression',
  [GA_KEY.TABLE_SORT_CTR]: 'keyword_list_orderclickrate',
  [GA_KEY.VIEW_GD]: 'keyword_list_viewgd'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [TABLE_SORT_FIELD.CLICKS]: GA_KEY.TABLE_SORT_CLICKS,
        [TABLE_SORT_FIELD.IMPRESSIONS]: GA_KEY.TABLE_SORT_IMPRESSIONS,
        [TABLE_SORT_FIELD.CTR]: GA_KEY.TABLE_SORT_CTR
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.VIEW_GD:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    category: 'topkeyword',
    action: 'topkeywordlist',
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
